<template>
  <div :class="breadcrumbClass">
    <div class="float-left">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-for="item in items" :class="{ active: item.active }">
          <a @click="$router.push(item.href)" :class="{ breadcrumbTemporarioSemLink: !item.href }">{{ item.text }}</a>
        </li>
      </ol>
    </div>

    <div class="clearfix"></div>
  </div>
</template>

<script>
import LoginUtils from '@/core/utils/login-utils'
import UsuarioAPI from '@/api/usuario-api'

export default {
  name: 'Breadcrumb',
  props: {
    breadcrumbClass: {
      type: String,
      default: 'bread-night'
    },
    items: {
      type: Array
    },
    breadCrumbItemClass: {
      type: String,
      default: 'breadcrumb-item'
    }
  },
  data () {
    return {
      modoNoturno: false
    }
  },
  mounted () {
    if (LoginUtils.getUsuario().modo_noturno === 1) {
      this.modoNoturno = true
    } else {
      this.modoNoturno = false
    }
  },
  watch: {
    modoNoturno: function () {
      let usuario = JSON.parse(localStorage.getItem('usuario'))
      if (this.modoNoturno) {
        usuario.modo_noturno = 1
        document.body.classList.add('darkMode')
      } else {
        usuario.modo_noturno = 0
        document.body.classList.remove('darkMode')
      }
      localStorage.setItem('usuario', JSON.stringify(usuario))
    }
  },
  methods: {
    alternarDarkMode () {
      UsuarioAPI.alternarDarkMode()
    }
  }
}
</script>

<style scoped>
  .breadcrumbTemporarioSemLink {
    cursor: text;
  }
</style>
